import mapValues from 'lodash/mapValues'

export const getQueryParamsString = <T extends object>(queryParams: T): string => {
  const stringQueryParams = mapValues(queryParams, String)
  const searchParams = new URLSearchParams(stringQueryParams)
  return searchParams.toString()
}
